import { Component, OnInit } from '@angular/core';
import { res } from '../../../../common/language/text/res';
import { Subject } from 'rxjs';
import { UserRole } from '../../../../common/model/UserRole';
import { UserPermission } from '../../../../common/model/UserPermission';
import { ConfirmationService } from '../../../../common/facade/confirmation.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SecurityFacade } from '../../../../common/facade/SecurityFacade';
import { Strings } from '../../../../common/language/strings';
import { DualListComponent } from 'angular-dual-listbox';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-role-permissions-modal',
  templateUrl: './role-permissions-modal.component.html',
  styleUrls: ['./role-permissions-modal.component.css']
})
export class RolePermissionsModalComponent implements OnInit {
  // Labels and text
  public modalTitle: res;
  public modalSave: res;
  public modaLoading: res;

  public errorGettingPermissions: res;
  public errorSavingPermissions: res;

  public role: UserRole;
  public onClose$: Subject<number>;

  public permissions: UserPermission[];
  public rolePermissions: UserPermission[];

  public alerts: { msg: string, type: string }[];

  public _loading: boolean;

  public dualListFormat;

  constructor(
    public strings: Strings,
    public bsModalRef: BsModalRef,
    private securityService: SecurityFacade,
    private confirmationService: ConfirmationService
  ) { 
    this.modalTitle = res.Roles;
    this.modalSave = res.Save;
    this.modaLoading = res.Loading;

    this.errorGettingPermissions = res.ErrorGettingPermissions;
    this.errorSavingPermissions = res.ErrorSavingPermissions;

    this.role = new UserRole();
    this.onClose$ = new Subject();

    this.permissions = [];
    this.rolePermissions = [];

    this.alerts = [];
    this._loading = false;

    this.dualListFormat = DualListComponent.DEFAULT_FORMAT;
    this.dualListFormat.add = this.strings.GetText(res.Add);
    this.dualListFormat.remove = this.strings.GetText(res.Delete);
    this.dualListFormat.all = this.strings.GetText(res.AllO);
    this.dualListFormat.none = this.strings.GetText(res.None);
  }

  ngOnInit(): void {
    this.getRolePermissions()
  }

  public closeModal(): void {
    this.onClose$.next(0);
    this.bsModalRef.hide();
  }

  public getRolePermissions(): void {
    this._loading = true;
    this.securityService.GetPermissions(this.role.roleID)
    .pipe(finalize(() => this._loading = false))
    .subscribe(rolePermissions => {
      if (!rolePermissions.completed)
        return;

      this.rolePermissions = rolePermissions.data;

    }, error => {
      this.addAlert(`<strong> ${this.strings.GetText(this.errorGettingPermissions)} </strong>`, 'danger');
    });
  }

  public async saveRolePermissions(): Promise<void> {
    const result: boolean = await this.confirmationService.confirm();
    if (!result)
      return;
    
    this._loading = true;
    this.securityService.UpdateRolePermissions(this.role, this.rolePermissions)
    .pipe(finalize(() => this._loading = false))
    .subscribe(result => {
      if (!result.completed)
        return;

      this.onClose$.next(1);
      this.bsModalRef.hide();

    }, error => {
      this.addAlert(`<strong> ${this.strings.GetText(this.errorSavingPermissions)} </strong>`, 'danger');
    });
  }

  public addAlert(message: string, type: string): void {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  public onAlertClose(dismissedAlert: { msg: string, type: string }): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

}
